<template>
  <v-app>
    <router-view />
    <Snackbar></Snackbar>
    <AppUpdateModal></AppUpdateModal>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import Snackbar from './components/core/Snackbar.vue';
import AppUpdateModal from './components/core/AppUpdateModal.vue';
import SnackbarMixin from './mixins/snackbar';
import USER_ROLES from './utils/user';

export default {
  name: 'App',
  components: {
    Snackbar,
    AppUpdateModal,
  },
  computed: {
    ...mapState({
      currentUser: ({ currentUser }) => currentUser,
      userLogged: ({ userLogged }) => userLogged,
    }),
  },
  mixins: [SnackbarMixin],
  watch: {
    currentUser: {
      handler(nValue) {
        if (
          this.userLogged
          && nValue
          && nValue.roles?.includes(USER_ROLES.SCHOOL_GROUP_ADMIN)
          && this.$route.path.startsWith('/login')
        ) {
          this.$router.push('/school');
          return;
        }

        if (
          this.userLogged
          && nValue
          && nValue.roles?.includes(USER_ROLES.ADMIN)
          && this.$route.path.startsWith('/login')
        ) {
          this.$router.push('/dashboard');
        }
      },
      immediate: true,
    },
  },
};
</script>
